import {Container, DisplayObject} from 'pixi.js';

export interface IContainerList {
    direction?: 'column' | 'row';
    gapBetweenChildren?: number;
    wrap?: number;
}

type Children = DisplayObject & {width?: number; height?: number;};

export class ContainerList extends Container implements IContainerList {
    public direction: 'column' | 'row' = 'column';
    public gapBetweenChildren = 0;
    public wrap = 0;

    protected onChildrenChange(): void {
        this.updatePositionOfChildren();
    }

    public updatePositionOfChildren(): void {
        const {wrap, gapBetweenChildren, direction, children} = this;
        let x = 0;
        let y = 0;

        (children as Children[]).forEach(child => {
            const childWidth = child.width ?? 0;
            const childHeight = child.height ?? 0;

            child.position.set(x, y);

            x = direction === 'column' ? x : x + childWidth + gapBetweenChildren;
            y = direction === 'row' ? y : y + childHeight + gapBetweenChildren;

            if (wrap > 0) {
                if (direction === 'row' && x >= wrap) {
                    x = 0;
                    y += childHeight + gapBetweenChildren;
                } else if (direction === 'column' && y >= wrap) {
                    y = 0;
                    x += childWidth + gapBetweenChildren;
                }
            }
        });
    }
}